import React from 'react';

import JoinEventNotificationView from './JoinEventNotificationView';
import { useMessageData, useNotification } from '../hooks';

import { IJoinEventNotification } from './interfaces';

const JoinEventNotification = ({
  ref,
  id,
  message,
  type,
  onJoin,
}: IJoinEventNotification) => {
  const { hideNotification } = useNotification();
  const { color, background, isTheme, icon } = useMessageData(type);

  return (
    <JoinEventNotificationView
      ref={ref}
      message={message}
      color={color}
      isTheme={isTheme}
      icon={icon}
      background={background}
      onJoin={onJoin}
      onClickClose={() => hideNotification(id)}
    />
  );
};

export default JoinEventNotification;
